import styled, { css } from 'styled-components';
import { theme } from '../../../config';

export const FieldsContainer = styled.span``;

export const TextComponentWrapper = styled.div`
  height: 5.3rem;
  display: flex;
  flex-direction: column;
`;

export const NameFieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media ${theme.breakpoints.mobile} {
    flex-direction: column;
  }
`;

export const NameFieldWrapper = styled.div`
  width: 45%;
  height: 4.9rem;
  @media ${theme.breakpoints.mobile} {
    width: 100%;
  }
`;

const helperTextStyle = css`
  font-family: ${theme.fonts.default};
  font-size: 10px;
  line-height: 0;
`;

export const HelperTextSymbol = styled.p`
  ${helperTextStyle};
  color: ${theme.colors.red.primary};
`;

export const HelperText = styled.p`
  ${helperTextStyle};
  @media ${theme.breakpoints.mobile} {
    color: black;
  }
`;

export const HelperTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1;
  margin-top: 0.6rem;
  @media ${theme.breakpoints.mobile} {
    display: none;
  }
`;

export const HelperTextContainerToolTip = styled.div`
  @media ${theme.breakpoints.mobile} {
    display: flex;
    flex-direction: row;
    flex: 1;
  }
`;

export const CheckboxContainer = styled.div`
  height: 21px;
  margin-top: 1.8rem;
`;

export const ErrorMessageContainer = styled.div<{ isEmpty: boolean }>`
  margin-top: 0.25rem;
  display: ${(props): string => (props.isEmpty ? 'none' : 'block')};
  flex-direction: column;
  min-height: fit-content;
  @media ${theme.breakpoints.mobile} {
    width: 85%;
    max-width: 372px;
    margin-top: -0.1rem;
  }
`;

export const ErrorMessage = styled.p`
  ${theme.defaultErrorText}
  color: ${theme.colors.red.primary};
  font-size: 0.75rem;
  line-height: 1rem;
  width: 100%;
  word-break: break-all;
`;

export const ErrorMessageWrapper = styled.div`
  display: flex;
`;

export const QuestionMarkContainer = styled.div`
  @media ${theme.breakpoints.mobile} {
    width: 7px;
    height: 16px;
    margin-left: 4.5px;
  }
`;

export const IconWrapper = styled.div`
  @media ${theme.breakpoints.mobile} {
    position: absolute;
    margin-top: 1px;
    z-index: -1;
  }
`;

export const ToolTipContainer = styled.div`
  @media ${theme.breakpoints.mobile} {
    flex: 1;
    justify-content: right;
  }
  @media ${theme.breakpoints.pcAndTablet} {
    display: none;
  }
`;

export const ToolTipWrapper = styled.div`
  @media ${theme.breakpoints.mobile} {
    float: right;
    margin-top: 9px;
    margin-right: 5px;
  }
`;
